module.exports = __webpack_public_path__ + "media/step8_animation.293d6eca.webm";